import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, map, take, timeout } from 'rxjs/operators';
import { getAuthToken, RequestAuthToken, SetAuthToken } from '../state';
import {
  getStoredAuthToken,
  getStoredUserType,
  handleContractorLogout,
  isContractorLoggedOut,
  isContractorSession,
} from '@libraries/helpers';

@Injectable({
  providedIn: 'root',
})
export class CanActivateApplyGuard implements CanActivate {
  constructor(private store: Store, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isContractor =
      isContractorSession() ||
      getStoredUserType() === 'contractor' ||
      (typeof sessionStorage !== 'undefined' &&
        (sessionStorage.getItem('apply_user_type') === 'contractor' ||
          sessionStorage.getItem('is_contractor_session') === 'true'));

    if (
      isContractor &&
      isContractorLoggedOut() &&
      window === window.parent &&
      (!window.opener || window.opener.closed)
    ) {
      handleContractorLogout('logged_out_in_other_tab');
      return false;
    }

    const storedToken = getStoredAuthToken();
    const storedUserType = getStoredUserType();

    if (
      isContractor &&
      !storedToken &&
      window === window.parent &&
      (!window.opener || window.opener.closed)
    ) {
      handleContractorLogout('missing_token');
      return false;
    }

    if (storedToken) {
      this.store.dispatch(
        SetAuthToken({ authToken: storedToken, userType: storedUserType || undefined })
      );
    }

    if (window !== window.parent || (window.opener && !window.opener.closed)) {
      this.store.dispatch(RequestAuthToken());
      return this.store.pipe(
        select(getAuthToken),
        filter((authToken) => !!authToken),
        take(1),
        timeout({ each: 3000, with: () => of(storedToken || null) }),
        map((token) => {
          if (!token && (isContractor || isContractorSession())) {
            handleContractorLogout('missing_token');
            return false;
          }
          return true;
        })
      );
    } else {
      return true;
    }
  }
}

